$('.js-smooth-scroll').click(function (event) {
  var id = $(this).attr('href');
  var $id = $(id);
  var _offset = $id.offset().top;

  if ($id.length === 0) {
    return;
  }

  event.preventDefault();

  $('body, html').animate({ scrollTop: _offset }, 1000);
});
